jQuery(document).ready(function ($) {

  // Only run on pages with .post-filter-grid
  if (!$('.post-filter-grid').length) {
    return;
  }

  const items = document.querySelectorAll('.post-filter-grid .post-item');
  const years = new Set();

  // Extract the years from the class names
  items.forEach(item => {
    const classList = item.classList;
    classList.forEach(className => {
      if (!isNaN(className) && className.length === 4) {
        years.add(className);
      }
    });
  });

  $(".filter-button").on('click', function () {
    $(this).toggleClass("active");
  });

  $(".filter-button").on('click', function () {
    $(this).siblings().removeClass("active");
    $(this).siblings().find('.filter-button').prop("checked", false);
  });

  var itemSelector = ".post-item";
  var $checkboxes = $('.filter-button');
  var $container = $('.post-filter-grid').isotope({ itemSelector: itemSelector });

  var responsiveIsotope = [[480, 12], [720, 12]];
  var itemsPerPageDefault = 12;
  var itemsPerPage = defineItemsPerPage();
  var currentNumberPages = 1;
  var currentPage = 1;
  var currentFilter = '*';
  var filterAttribute = 'data-filter';
  var filterValue = "";
  var pageAttribute = 'data-page';
  var pagerClass = 'isotope-pager';

  function changeFilter(selector) {
    $container.isotope({ filter: selector });
  }

  function goToPage(n) {
    currentPage = n;
    var selector = itemSelector;
    var exclusives = [];

    $checkboxes.each(function (i, elem) {
      if (elem.checked) {
        selector += (currentFilter != '*') ? '.' + elem.value : '';
        exclusives.push(selector);
      }
    });

    filterValue = exclusives.length ? exclusives.join('') : '*';
    var wordPage = currentPage.toString();
    filterValue += ('.' + wordPage);

    changeFilter(filterValue);
  }

  function defineItemsPerPage() {
    var pages = itemsPerPageDefault;

    for (var i = 0; i < responsiveIsotope.length; i++) {
      if ($(window).width() <= responsiveIsotope[i][0]) {
        pages = responsiveIsotope[i][1];
        break;
      }
    }
    return pages;
  }

  function setPagination() {

    (function SettingsPagesOnItems() {

      var itemsLength = $container.children(itemSelector).length;
      var pages = Math.ceil(itemsLength / itemsPerPage);
      var item = 1;
      var page = 1;
      var selector = itemSelector;
      var exclusives = [];

      $checkboxes.each(function (i, elem) {
        if (elem.checked) {
          selector += (currentFilter != '*') ? '.' + elem.value : '';
          exclusives.push(selector);
        }
      });

      filterValue = exclusives.length ? exclusives.join('') : '*';

      $container.children(filterValue).each(function () {

        if (item > itemsPerPage) {
          page++;
          item = 1;
        }

        var wordPage = page.toString();
        var classes = $(this).attr('class').split(' ');
        var lastClass = classes[classes.length - 1];

        if (lastClass.length < 4) {
          $(this).removeClass();
          classes.pop();
          classes.push(wordPage);
          classes = classes.join(' ');
          $(this).addClass(classes);
        } else {
          $(this).addClass(wordPage);
        }

        item++;
      });

      currentNumberPages = page;

    })();

    (function CreatePagers() {

      var $isotopePager = ($('.' + pagerClass).length == 0)
        ? $('<div class="' + pagerClass + '" />')
        : $('.' + pagerClass);

      $isotopePager.html('');

      if (currentNumberPages > 1) {
        for (var i = 0; i < currentNumberPages; i++) {
          var $pager = $('<a href="javascript:void(0);" class="pager" ' + pageAttribute + '="' + (i + 1) + '"></a>');
          $pager.html(i + 1);

          $pager.click(function () {
            var page = $(this).eq(0).attr(pageAttribute);
            goToPage(page);
          });

          $pager.appendTo($isotopePager);
        }
      }

      $container.after($isotopePager);

    })();
  }

  function clearAll() {
    $checkboxes.each(function (i, elem) {
      if (elem.checked) {
        elem.checked = null;
      }
    });

    currentFilter = '*';
    setPagination();
    goToPage(1);
  }

  setPagination();
  goToPage(1);

  $checkboxes.change(function () {
    var filter = $(this).attr(filterAttribute);
    currentFilter = filter;
    setPagination();
    goToPage(1);
  });

  $(window).resize(function () {
    itemsPerPage = defineItemsPerPage();
    setPagination();
    goToPage(1);
  });

});